var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("messages"),
      _vm._v(" "),
      _c("navBar"),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _vm.onUploadPage || (!_vm.newProviderPosted && _vm.isCreateMode)
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-offset-1 col-md-10" },
                [_c("router-view", { attrs: { id: "content" } })],
                1
              )
            ])
          : _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-2" },
                [
                  _vm.authenticated && !_vm.isNullMode && !_vm.onUploadPage
                    ? _c("sideNav")
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-10" },
                [_c("router-view", { attrs: { id: "content" } })],
                1
              )
            ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 87
// module chunks = 0